import { api } from 'shared/api';
import { Language } from 'shared/const/languages';

const _api = api.injectEndpoints({
  endpoints: (build) => ({
    changeLanguage: build.mutation({
      query: (language: Language) => ({
        url: '/user/language',
        params: { language: language.toUpperCase() },
        method: 'PUT'
      })
    })
  }),
})

export const { useChangeLanguageMutation } = _api;